import { useState } from 'react'
import { Download, X } from 'lucide-react'
import { useLiveUpdateStore } from './liveUpdateStore'
import { applyPendingUpdate, discardPendingUpdate } from '@/core/platform/liveUpdate'

/**
 * Faixa amarela fixa no topo da viewport quando há um bundle baixado aguardando
 * aplicação. Lê `pendingUpdate` do liveUpdateStore.
 *
 * UX: cor amarela = atenção mas não crítico; botão "Atualizar agora" é o CTA
 * primário (texto preto sobre amarelo, alto contraste); "Mais tarde" só dispensa
 * o banner — não descarta o bundle no plugin (volta no próximo check periódico).
 */
export function UpdateBanner() {
  const pending = useLiveUpdateStore((s) => s.pendingUpdate)
  const [applying, setApplying] = useState(false)

  if (!pending) return null

  async function handleApply() {
    setApplying(true)
    await applyPendingUpdate()
    // reload acontece dentro do applyPendingUpdate; este componente some junto.
  }

  return (
    <div className="sticky top-0 z-50 bg-warn text-black border-b border-black/20 shadow-md">
      <div className="max-w-2xl mx-auto px-3 py-2 flex items-center gap-2 text-sm">
        <Download className="h-4 w-4 shrink-0" aria-hidden />
        <div className="flex-1 min-w-0">
          <span className="font-semibold">Nova versão disponível</span>{' '}
          <span className="font-mono text-xs opacity-80">{pending.version}</span>
        </div>
        <button
          onClick={handleApply}
          disabled={applying}
          className="h-8 px-3 rounded-md bg-black text-warn font-semibold text-xs disabled:opacity-60"
        >
          {applying ? 'Aplicando…' : 'Atualizar agora'}
        </button>
        <button
          onClick={discardPendingUpdate}
          aria-label="Mais tarde"
          className="h-8 w-8 inline-flex items-center justify-center rounded-md hover:bg-black/10"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
